import { LoginModalActionType } from '../actiontype/login-modal.actiontype';
import { AppModalActionType } from '../actiontype/app-modal.actiontype';
import AuthorizationActionType from '../actiontype/authorization.actiontype';
import ApiStatus from '../constants/api-status.enum';

const initialState = {
    loginFormValidated: false,
    invalidAirtelNumber: false,
    userId: '',
    otpSentFailed: false,
    otpSentFailedMessage: '',
    loginInfoApiStatus: '',
    loginInfoApiResponse: '',
    checkUserApiStatus: '',
    checkUserApiResponse: '',
    generateOtpApiStatus: '',
    generateOtpApiResponse: '',
}

export default function (state = initialState, action) {
    switch (action.type) {
        case LoginModalActionType.LOGIN_FORM_VALIDATED:
            return {
                ...state,
                loginFormValidated: action.payload
            }
        case LoginModalActionType.INVALID_AIRTEL_NUMBER:
            return {
                ...state,
                invalidAirtelNumber: action.payload
            }
        case LoginModalActionType.USER_ID:
            return {
                ...state,
                userId: action.payload
            }
        case LoginModalActionType.OTP_SENT_FAILED:
            return {
                ...state,
                otpSentFailed: action.payload.status,
                otpSentFailedMessage: action.payload.message
            }
        case AuthorizationActionType.LOGIN_INFO_LOADING:
            return {
                ...state,
                loginInfoApiStatus: ApiStatus.LOADING,
                loginInfoApiResponse: action.payload
            }
        case AuthorizationActionType.LOGIN_INFO_SUCCESS:
            return {
                ...state,
                loginInfoApiStatus: ApiStatus.SUCCESS,
                loginInfoApiResponse: action.payload
            }
        case AuthorizationActionType.LOGIN_INFO_ERROR:
            return {
                ...state,
                loginInfoApiStatus: ApiStatus.ERROR,
                loginInfoApiResponse: action.payload
            }
        case AuthorizationActionType.CHECK_USER_LOADING:
            return {
                ...state,
                checkUserApiStatus: ApiStatus.LOADING,
                checkUserApiResponse: action.payload
            }
        case AuthorizationActionType.CHECK_USER_SUCCESS:
            return {
                ...state,
                checkUserApiStatus: ApiStatus.SUCCESS,
                checkUserApiResponse: action.payload
            }
        case AuthorizationActionType.CHECK_USER_ERROR:
            return {
                ...state,
                checkUserApiStatus: ApiStatus.ERROR,
                checkUserApiResponse: action.payload
            }
        case AuthorizationActionType.GENERATE_OTP_LOADING:
            return {
                ...state,
                generateOtpApiStatus: ApiStatus.LOADING,
                generateOtpApiResponse: action.payload
            }
        case AuthorizationActionType.GENERATE_OTP_SUCCESS:
            return {
                ...state,
                generateOtpApiStatus: ApiStatus.SUCCESS,
                generateOtpApiResponse: action.payload
            }
        case AuthorizationActionType.GENERATE_OTP_ERROR:
            return {
                ...state,
                generateOtpApiStatus: ApiStatus.ERROR,
                generateOtpApiResponse: action.payload
            }

        case AppModalActionType.RESET_MODAL:
            return {
                ...state,
                loginFormValidated: false,
                invalidAirtelNumber: false,
                userId: '',
                otpSentFailed: false,
                otpSentFailedMessage: ''
            }

        default:
            return state;
    }
}